import React from "react";
import API from "../base/API";
import { Modal } from "react-bootstrap";
import { getUser } from "../auth/Auth"
import { translate } from "../base/Translation";

export default class OppositionFormEdit extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_form: "/form/fetch/:form",
            save_opposition: "/opposition/save/:opposition",
            get_question_answers: "/answer/fetch/by/question/:question?form=:form&test=:test"
        });

        this.state = {
            answers: [],
            notes: [],
            form: false,
            form_protocol: false,
            dataFeed: false,
            selectedForm: 0,
            selectedSection: 0,
            selectedGroup: 0,
            selectedQuestion: 0,
            opposition: this.props.data.text,
        }
    }

    componentDidMount() {
    }

    onSave() {
        const opposition = {
            text: this.state.opposition,
        };

        this.api.request({
            route: "save_opposition",
            params: { opposition: this.props.data.id },
            data: opposition,
            created: (response) => {
                alert(translate("Námietka bola úspešne uložená ako koncept."));
                this.props.reload();
                this.close();
                window.dispatchEvent(new Event("reloadLog"));
            }
        })
    }

    close() {
        this.setState({ showModal: false });
    }

    open() {
        this.setState({ showModal: true });
    }

    render() {

        if(this.props.data.user.role !== getUser().role || this.props.data.status === "published") {
            return <span/>
        }

        if (!this.state.showModal) {
            return (
                <small>&#9702; <a style={{ cursor: "pointer" }} onClick={this.open.bind(this)}>{translate("Upraviť")}</a></small>
            )
        }

        return (
            <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>{translate("Upraviť námietku")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label className="control-label">{translate("Vaša námietka")}</label>
                        <textarea className="form-control" defaultValue={this.props.data.text} onChange={(evt) => {
                            this.setState({ opposition: evt.target.value });
                        }} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={this.onSave.bind(this)}><i className="fa fa-save" />&nbsp; {translate("Uložiť")}</button>
                    <button className="btn btn-danger" onClick={this.close.bind(this)}><i className="fa fa-close" />&nbsp; {translate("Zrušiť zmeny")}</button>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/opposition/OppositionFormEdit.jsx